const formatDate = (dateString) => {
  const date = new Date(dateString)
  const formattedDate = new Intl.DateTimeFormat('ru', { year: 'numeric', month: 'long', day: '2-digit' })
  const [{ value: day },, { value: month },, { value: year }] = formattedDate.formatToParts(date)
  
  return `${day} ${month} ${year}`
}

export default formatDate
